import { fetchGet, rootApi } from '../helpers/api';

import { getToken } from '../helpers/common';

const graphApi = `${rootApi}/graph`;
const totalizeApi = `${rootApi}/stations/statistic/totalize`;

var fastDataEventSource = null;
var healthDataEventSource = null;

export const startFastDataStreaming = (userId, stationName, callback) => {
  if(fastDataEventSource)
    fastDataEventSource.close();
  console.log(`${userId}:${stationName}`);
  const data =  btoa(`${userId}:${stationName}`);
  fastDataEventSource = new EventSource(`${graphApi}/realtime?d=${data}&Authorization=${getToken()}`,);
  fastDataEventSource.onmessage = function(e) {
    if(e.data){
      let data = JSON.parse(e.data);
      if(data.stationId){
        callback(data);
      }
    }
  };
}

export const closeFastDataStream = () => {
  if(fastDataEventSource){
    fastDataEventSource.close();
    fastDataEventSource = null;
  }
}

export const startHealthDataStreaming = (userId, stationName, callback) => {
  if(fastDataEventSource)
    fastDataEventSource.close();

  const data =  btoa(`${userId}:${stationName}`);
  fastDataEventSource = new EventSource(`${graphApi}/realtime-health?d=${data}&Authorization=${getToken()}`);
  fastDataEventSource.onmessage = function(e) {
    if(e.data){
      let data = JSON.parse(e.data);
      if(data.stationId){
        callback(data);
      }
    }
  };
}

export const closeHealthDataStream = () => {
  if(healthDataEventSource)
    healthDataEventSource.close();
}

export const getTotalize = (stationId) => fetchGet(`${totalizeApi}/${stationId}`);